@import '../../../theme.scss';

verdocs-adopt-signature-dialog {
  font-family: $primary-font;
  box-sizing: border-box;

  verdocs-dialog {
    border-radius: 4px;
  }

  .heading {
    color: #201f1e;
    font-weight: 400;
    padding-bottom: 0;
    border-bottom: none;
  }

  .content {
    display: flex;
    padding: 12px 24px 0;
    flex-direction: column;
  }

  .name-locked-hint {
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
  }

  verdocs-text-input .input-label {
    color: #242424;
    font-size: 13px;
    font-weight: 400;
  }

  verdocs-text-input .input-element {
    border: 1px solid #e0e0e0;
  }

  verdocs-radio-button {
    transform: scale(0.9);
  }

  .canvas-container {
    position: relative;
    width: 100%;
    margin: 10px 0;
    border-radius: 4px;
    background: #fafafa;
    border: 1px solid #d1d1d1;
    box-sizing: border-box;

    &.initials-container {
      max-width: 50%;
    }

    canvas {
      width: 100%;
      height: 79px;
      border-radius: 4px;
      /* Background must be transparent to show the guide */
      background: transparent;
      box-sizing: border-box;
      /* Border is handled by container */
      border: none;
      position: relative;
      z-index: 2;
    }

    .signing-indicator {
      position: absolute;
      bottom: 9px;
      left: 9px;
      right: 9px;
      height: 28px;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      gap: 2px;
      z-index: 1;
      pointer-events: none;

      .x-icon {
        width: 25px;
        height: 28px;
        display: flex;

        svg {
          width: 100%;
          height: 100%;
        }
      }

      .signing-line {
        flex: 1;
        /* "The line is a 1px dashed (8px dash 8px space) #d1d1d1 line". This works in SOME browsers. */
        border-bottom: 1px dashed #d1d1d1;
        background-position: bottom;
        background-size: 16px 1px;
        /* 8px dash + 8px space = 16px repeat */
        background-repeat: repeat-x;
        margin-bottom: 0;
        /* Since standard border-style: dashed doesn't allow custom spacing, we use a background gradient
           trick or just rely on standard dashed if acceptable.
        */
        height: 1px;
        border: none;
        background-image: linear-gradient(to right, #d1d1d1 50%, transparent 50%);
      }
    }
  }

  .disclaimer {
    padding: 8px 0;
    font-size: 11px;
    line-height: 14px;
    text-align: justify;
    color: rgba(0, 0, 0, 0.54);
  }

  .tabs {
    display: flex;
    flex-direction: row;
    margin: -20px -20px 0 -20px;
    border-bottom: 1px solid #eeeeee;

    .tab {
      flex: 1;
      gap: 4px;
      display: flex;
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
      padding: 6px 10px;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      &.active {
        background: #f9f5fe;
        border-bottom: 2px solid $border-color;
      }

      &:hover {
        color: $primary-color;
      }

      .icon {
        width: 16px;
        height: 16px;
      }
    }
  }

  // We use fixed heights for these sections to avoid layout shifts when switching tabs.
  .type {
    display: none;
    flex-direction: column;

    &.active {
      display: flex;
    }
  }

  .draw {
    height: 100px;
    display: none;
    margin-top: 20px;
    flex-direction: column;

    &.active {
      display: flex;
    }

    .draw-instructions {
      font-size: 13px;
      color: rgba(0, 0, 0, 0.6);
      margin-bottom: 8px;
      text-align: center;
    }

    canvas {
      cursor: crosshair;
      touch-action: none;
    }
  }

  .preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;

    .clear-button-text {
      background: none;
      border: none;
      color: var(--verdocs-primary-color, #{$verdocs-green});
      cursor: pointer;
      font-size: 13px;
      padding: 0;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }

      &:disabled {
        color: #9ca3af;
        text-decoration: none;
        cursor: not-allowed;
      }
    }
  }

  .upload {
    height: 100px;
    display: none;
    margin-top: 20px;
    flex-direction: column;

    &.active {
      display: flex;
    }

    .upload-instructions {
      font-size: 13px;
      color: rgba(0, 0, 0, 0.6);
      margin-bottom: 8px;
      text-align: center;
    }

    .upload-actions {
      display: flex;
      justify-content: center;
      gap: 12px;
      margin-top: 8px;

      .upload-button {
        border: 1px solid var(--verdocs-primary-color, #{$verdocs-green});
        background-color: var(--verdocs-primary-color, #{$verdocs-green});
        color: #ffffff;
        padding: 8px 20px;
        font-size: 13px;
        cursor: pointer;
        border-radius: var(--verdocs-button-radius, 4px);
        transition: all 0.2s ease;

        &:hover {
          filter: brightness(0.9);
        }
      }

      .clear-button {
        border: 1px solid #d0d0d0;
        background-color: #ffffff;
        color: #333333;
        padding: 8px 16px;
        font-size: 13px;
        cursor: pointer;
        border-radius: 4px;
        transition: all 0.2s ease;

        &:hover:not(:disabled) {
          background-color: #f5f5f5;
          border-color: #b0b0b0;
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }

    .upload-filename {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.6);
      text-align: center;
      margin-top: 8px;
      font-style: italic;
    }
  }

  /* TODO: We're getting positive feedback. Add this as a formal button variant. */
  .buttons {
    gap: 20px;
    display: flex;
    margin-top: 14px;
    flex-direction: row;
    justify-content: flex-end;

    button {
      flex: 1;
      border: 0;
      height: 38px;
      display: flex;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      align-items: center;
      border-radius: var(--verdocs-button-radius, 6px);
      justify-content: center;
      transition: all 0.2s ease;

      &.cancel {
        background-color: transparent;
        border: 1px solid #d1d5db;
        color: #374151;

        &:hover {
          background-color: #f9fafb;
        }
      }

      &.proceed {
        background-color: var(--verdocs-primary-color, #{$verdocs-green});
        border: 1px solid transparent;
        color: #ffffff;

        &:hover {
          background-color: var(--verdocs-primary-color-hover, #{$verdocs-green-shade});
          filter: brightness(0.95);
        }
      }

      &:disabled {
        background-color: #e5e7eb;
        color: #9ca3af;
        cursor: not-allowed;
      }
    }
  }
}
